module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_null@2x.3166ce38.png";